import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormControl, Validators, UntypedFormGroup, UntypedFormBuilder, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { ApplicationService } from 'app/services/application.service';
import { PopupService } from '../../../services/shared/popup.service';
import {DocumenttypeService} from 'app/services/documenttype.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { VehicleService } from 'app/services/vehicle.service';
import { AuthWebService } from 'app/services/authweb.service';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { Account } from 'app/constants/account.enum';
import { DomSanitizer } from '@angular/platform-browser';
import { PermitTypeDocumentService } from 'app/services/permit-type-document.service';
import { CompliancereturnsService } from 'app/services/compliancereturns.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'uploads-viewer',
  templateUrl: './uploads-viewer.component.html',
  styleUrls: ['./uploads-viewer.component.css'],
  providers:[PermitTypeDocumentService]
})
export class UploadsViewerComponent implements OnInit {

  @Input() dataCntrl: any;
  @Input() isPermitApproval : boolean = false;
  @Input() isComplianceDocuments : boolean = false;
  @Input() complianceDetailId : any;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  

  form: UntypedFormGroup;
  model : any = [];
  tabload:boolean=false;
  listUploadRows:any=[];
  isLoading:boolean=false;
  UserDocuments:any=[];
  docTypesList:any=[];
  doctypesCodes:any=[];
  haserror:boolean=false;
  disableAdd:boolean=false;
//Uploaded file data
filebytes: string;
filename: string;
filetype: string;
filesize: string;
filedescription: string;
img:any;
user = { LastName: '' };
PermitDocTypesList:any =[];
uploadInfo:any[] = [];

docTypeId: any;
doctypesDesc: any;
page = 1;

uploadedDocs:any =[];
docTypeData:any = null;
isLoadingImg: boolean = false;
pdfSrc:any;
isTrue : boolean = false;
disableBtn : boolean = false;
linkedDocs:any =[];

permitCompliance : any;



categories = [
  {id: "", name: "Select Document Type",value: ""},

];
carrier_type_id:any;

  constructor(private formBuilder: UntypedFormBuilder,private toastr: ToastrService,
    private showModal:PopupService,public applicationService: ApplicationService,
    private documenttypeService:DocumenttypeService,
    private router:Router,private permitService:PermitService,
    private vehicleService:VehicleService,
    private authWebService: AuthWebService,
    private documentService:DocumentsServiceService,
    private ref: ChangeDetectorRef,
    private utility: UtilityServiceService,
    private sanitizer: DomSanitizer,private activeRoute: ActivatedRoute,private service: PermitTypeDocumentService,
    private complianceService:CompliancereturnsService,
    private http: HttpClient,
    private modalService: NgbModal) { }

  ngOnInit() {
    
    if(this.router.url.indexOf('edit') > 0){
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id=  params['id'];
        if(environment.authWebApi.userData.Roles.find(p=>p.Code=='ADMIN')){
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
    }
     this.docTypeData = this.categories[0].id

    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';

    this.getDoctypesCodes();
    //this.populateDocTypeList();

    let docs = JSON.parse(localStorage.getItem("uploads") || "[]");
    //console.log(this.authWebService.userData)

    if(this.docTypesList.length === 0 && docs.length > 0){
      //console.log(docs)
      this.docTypesList = docs;
    }
    //console.log(this.dataCntrl.permittype.id)

    
    this.isLoading = true;
    this.documentService.getPermitById(this.dataCntrl.application.id).subscribe((x:any) => {      
      this.uploadedDocs = [];
      if(this.isPermitApproval && this.isComplianceDocuments)
      {
       
        
          for(var i = 0; i < x.length;i++){ 
              if(x[i].is_permit)    
              {
                if(x[i].compliance_detail_id  != null && x[i].compliance_detail_id  != undefined && x[i].compliance_detail_id  == this.complianceDetailId)
                {
                let fNum =  x[i].document_link.indexOf('#');               
                x[i].shareId = x[i].document_link.substring(fNum+1);                
                x[i].document_link = x[i].document_link.substring(0,fNum); 

                this.uploadedDocs.push(x[i]);
                }
                this.isLoading = false;
              } 
          }
        
      }
      else if(this.isPermitApproval)        
      {  
        for(var i = 0; i < x.length;i++){ 
         
            if(x[i].is_permit && (x[i].compliance_detail_id == null || x[i].compliance_detail_id== undefined || x[i].compliance_detail_id== 0))
            {
              let firstNum =  x[i].document_link.indexOf('#');     
              x[i].shareId = x[i].document_link.substring(firstNum+1);             
              x[i].document_link = x[i].document_link.substring(0,firstNum);
              
              this.uploadedDocs.push(x[i]);              
            }
          }


      }
      if (this.uploadedDocs.length > 0 )
       {
         this.removeUploadedDocTypes();
       }
      this.isLoading = false;


    },error =>{
      this.isLoading = false;

    })
    


  }
  getPermitData(){
   
    this.isLoading = true;
    this.permitService.getById(this.dataCntrl.permit.id).subscribe((result:any) => {
      this.carrier_type_id = result.carrier_type_id;
     // this.name = result.name;
      //Only call these guys once you have the type id you are looking for.
      //console.log(result)
      this.isLoading = false;

     // this.getCarrierExistingDocuments();
      
        
    }, error => {
      
      this.isLoading = false;
      // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier details.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Unable to retrieve carrier details.`,'Document Uploads')
    });
  }

  private downloadFile(url: string): any {
    return this.http.get(url, { responseType: 'blob' })
        .pipe(
            map((result: any) => {
                return result;
            })
        );
}

open(content) {
  this.modalService.open(content).result.then((result) => {
    // this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}


//  toggleModal() {
//     this.modal.classList.toggle("show-modal");
// }
  viewDoc(id,fileName){    
   
    this.isLoadingImg = true;
    
    this.pdfSrc = null;
    //let ext = fileName.substring(fileName.length-3,fileName.length);
   
    if(fileName.includes('.pdf')){
     
      this.documentService.downloadpdf(id).subscribe(x => {
       
        let objectURL = URL.createObjectURL(x);
            this.pdfSrc = objectURL;
               this.img = null;
              //  this.pdfViewerOnDemand.pdfSrc = objectURL; // pdfSrc can be Blob or Uint8Array
              //   this.pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
          this.isLoadingImg = false;
      });
      return;
    }

    this.documentService.download(id).subscribe(x => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc =null
        this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.img)
        this.isLoadingImg = false;
     // this.img = x;


    })

  }

  viewDocCompliance(id, fileName){    
   
    this.isLoadingImg = true;
    this.pdfSrc = null;
   
    if(fileName.includes('.pdf')){     
      this.documentService.downloadpdf(id).subscribe(x => {
          var  objectURL = URL.createObjectURL(x);
            this.pdfSrc = objectURL;
           this.pdfViewerOnDemand.pdfSrc = objectURL; // pdfSrc can be Blob or Uint8Array
        
           this.pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
          
                  
            document.getElementById("openModalButton"+id.toString()).click();
           

          this.isLoadingImg = false;  
          
  
      });
      return;
    }

    this.documentService.download(id).subscribe(x => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc =null
        this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.img)
        this.isLoadingImg = false;
     // this.img = x;


    })

  }
  populateDocTypeList()
  {
        // for this carrier get the related doc types
        
        this.service.getLinkedAndUnlinkedDoctypes(this.dataCntrl.permittype.id).subscribe(
          (result:any) => {
              //console.log(result);
              this.linkedDocs = result.PermitLinked;
          },
          error => {
              //console.log(error);
          }
      );
  
  
  }
  removeUploadedDocTypes()
  {
    this.isLoading = true;
//console.log('Phakathe inside')
 if (this.uploadedDocs.length > 0)
 {
   let count = this.uploadedDocs.length;
   for(let knt = 0; knt < count; knt++){

    let index = this.isDocTypeInList(this.uploadedDocs[knt].document_type_id);
    if (index != -1)
    {
      this.linkedDocs.splice(index,1);
    }
  }
  }
  this.isLoading = false;

  }
  isDocTypeInList(id: number) {
    let count = this.linkedDocs.length;
    for (let iter = 0; iter < count; iter++) {
        if (this.linkedDocs[iter].document_type_id == id) return iter;
    }
    return -1;
  }
  getDocSaved(id){
    this.documenttypeService.getById(id).subscribe(x =>{
      //console.log(x);
      this.doctypesDesc = x;
     });
  }
  getDoctypesCodes(){
    this.documenttypeService.getAll().subscribe(x =>{
      //console.log(x);
      this.doctypesCodes = x;
     });
    // this.doctypesCodes=[
    //   {
    //     "id": 1,
    //     "code": "CR",
    //     "description": "Insurance",
    //     "document_link": null,
    //     "is_template": false,
    //     "is_download": false,
    //     "group_code": "A",
    //     "sort_order": 1,
    //     "is_active": true,
    //     "display_ind": 3,
    //     "date_created": "2019-10-25T04:30:50.807",
    //     "date_modified": "2019-11-07T10:21:33.973",
    //     "user_created": "DEVUSER",
    //     "user_modified": "DEVUSER"
    //   },
    //   {
    //     "id": 2,
    //     "code": "SARS",
    //     "description": "Vehicle Licence",
    //     "document_link": null,
    //     "is_template": false,
    //     "is_download": false,
    //     "group_code": "A",
    //     "sort_order": 1,
    //     "is_active": true,
    //     "display_ind": 3,
    //     "date_created": "2019-10-25T05:57:57.493",
    //     "date_modified": "2019-11-07T10:18:49.367",
    //     "user_created": "DEVUSER",
    //     "user_modified": "DEVUSER"
    //   }
    // ]
  }

  changes(){
    this.form.statusChanges.subscribe(
      result => {
        this.dataCntrl.formValid = result == 'VALID'? true : false 
      }     
  );
  }
  backtoMotivation(){
      this.applicationService.setTab(4)
  }
  addNew(){
       let object:any={id:-1,permit_type_id:"",document_type_id:"",is_active:false,code:"",is_mandatory:false,description:"",editMode:true};
       this.docTypesList.push(object);


  }
  saveUploads(){
    for(let list of this.docTypesList){
      if(list.code!=""){
        list.id=0;
        list.permit_id = this.dataCntrl.permit.id;
        list.date_modified = list.date_created = new Date();
        list.user_modified = list.user_created = environment.authWebApi.userData.User.Username;
      }
    }
    this.haserror = false;
    this.disableAdd = false;
    this.dataCntrl.formValid = true;
    this.dataCntrl.permitTypesDocLinks=this.docTypesList;
    //console.log(this.dataCntrl.permitTypesDocLinks);
    this.toastr.success('Saved Step 5 Successfully','Step 5');
    this.applicationService.setTab(6);
  }
  uploadDocument(item,index){
    //console.log(item)
    document.getElementById("upload-"+index).click();
  }
  handleFileInput(event,id){
  
    const reader = new FileReader();

 
  


      if (event.target.files && event.target.files.length > 0) {
          let file: any = null
          const count = event.target.files.length
          file = event.target.files[count - 1];
          let result = this.checkFileType(file.name);
          // item.document_type_id = this.docTypeData.id;
          // item.code = this.doctypesDesc.code
          // item.description=file.name;
          this.docTypeId = id;
          // this.uploadInfo.push(this.docTypeData);
          // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
          let file: any = null
          const count = event.target.files.length
          
          file = event.target.files[count - 1];
          let result = this.checkFileType(file.name);
          
         

         //if File type is in not found
         if (result != -1) {

          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

          reader.removeEventListener
          reader.readAsDataURL(file);
          reader.onload = () => {

              this.filebytes = reader.result.toString().split(',')[1]
              this.filename = file.name,
              this.filetype = file.type
              this.filedescription = "upload"
              this.filesize = file.size
              this.validateData(this.docTypeId);

          };
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find( p => p.Code=='MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastr.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,'File Upload Failed, Please try again.');


          }
          
        }
        else
        {
          //send message allowed types
          // this.uploader.nativeElement.value = ''
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find( p => p.Code=='UploadDocTypes1');
          
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastr.error(`Only these file types are allowed: PDF`,'File Upload Failed, Please try again.')
        }

      }

      // this.uploader.nativeElement.value = ''
     // this.showOtherUploadsOption = false;

  }
  }
  fileUpload(event,item){
    //console.log('calling----->');
    // if(item.code.code = 'undefined')
    // {
    //   return this.toastr.warning('Please select the document type first!','Upload File')
    // }
    //console.log(item)
    

    
    const reader = new FileReader();

 
  


      if (event.target.files && event.target.files.length > 0) {
          let file: any = null
          const count = event.target.files.length
          file = event.target.files[count - 1];
          let result = this.checkFileType(file.name);
          item.document_type_id = this.doctypesDesc.id;
          item.code = this.doctypesDesc.code
          item.description=file.name;
          this.docTypeId =  item.document_type_id;
          this.uploadInfo.push(item);
          localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
          let file: any = null
          const count = event.target.files.length
          
          file = event.target.files[count - 1];
          let result = this.checkFileType(file.name);
          
         

         //if File type is in not found
         if (result != -1) {

          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

          reader.removeEventListener
          reader.readAsDataURL(file);
          reader.onload = () => {

              this.filebytes = reader.result.toString().split(',')[1]
              this.filename = file.name,
              this.filetype = file.type
              this.filedescription = "upload"
              this.filesize = file.size
              this.validateData(this.docTypeId);

          };
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find( p => p.Code=='MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastr.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,'File Upload Failed, Please try again.');


          }
          
        }
        else
        {
          //send message allowed types
          // this.uploader.nativeElement.value = ''
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find( p => p.Code=='UploadDocTypes1');
          
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastr.error(`Only these file types are allowed: PDF`,'File Upload Failed, Please try again.')
        }

      }

      // this.uploader.nativeElement.value = ''
     // this.showOtherUploadsOption = false;

  }
      
  }
  postFile( documenttypeid: any) {
  
    const formdata = new FormData()
    formdata.append('File', this.filebytes)
    formdata.append('FileName', this.filename)
    formdata.append('TypeOfFile', this.filetype)
    formdata.append('Notes', this.filedescription)
    formdata.append('FileSize', this.filesize)
    formdata.append('PermitId', this.dataCntrl.permit.id)
    formdata.append('PermitName','PermitName - '+this.filename)
    formdata.append('UserLastName', this.user.LastName)
    formdata.append('documenttypeid', documenttypeid)
    
    
    this.isLoadingImg = true;
    this.isLoading = true;
    // this.message = 'Uploading... please wait'
    
    this.documentService.postPermitDocument(formdata, documenttypeid, this.dataCntrl.application.id)
        .subscribe(
        response => {
          this.documentService.getPermitById(this.dataCntrl.application.id).subscribe((x:any) => {
            for(var i = 0; i < x.length;i++){
              let firstNum =  x[i].document_link.indexOf('#')
              //console.log(x[i].document_link.substring(firstNum+1))
              x[i].shareId = x[i].document_link.substring(firstNum+1);
              //console.log(x[i].document_link.substring(0,firstNum))
              this.uploadedDocs.id = x[i].document_link.substring(firstNum+1);
              x[i].document_link = x[i].document_link.substring(0,firstNum);
              //console.log(x)
              this.uploadedDocs = x;
              //console.log(this.uploadedDocs)
      
      
      
            }
            if (this.uploadedDocs.length > 0 )
             {
               this.removeUploadedDocTypes();
             }
      
      
          },error =>{
            this.isLoading = false;
      
          })
          this.isLoadingImg = false;
          this.isLoading = false;
                //  this.reload()//,
                //this.dialogService.addDialog(AlertComponent, {
                //    title: 'File Uploaded',
                //    message: 'File: ' + this.filename + ' was successfully uploaded.',
                //    bold: this.filename
                //})
                //console.log(response.document_type_id)
                this.toastr.success('File: ' + this.filename + ' was successfully uploaded.','File Upload')

                
                
        },
        error  => {
         this.isLoadingImg =false;  
         this.isLoading = false;

               
            // this.dialogService.addDialog(ErrorComponent, {
            //     title: 'File Upload Failed, Please try again.',
            //     message: error._body , statuscode: error.Status, url: error.Uri, servermessage: error.Message
            // }),
                this.toastr.error('File Upload Failed, Please try again.')
            // this.reload()
        })
  
  }
  
  checkFileType(fileName:string)
  {
    // from the file name derive the extension
    let allowedFileTypes = environment.authWebApi.systemData.Configurations.find( p => p.Code=='UploadDocTypes1');
    let fileTypesArray = allowedFileTypes.Value.toString().split(',');
    //check if file type is 
    let ext = fileName.split('.')[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
  }
  return -1;
  }
  
  checkFileSize(fileSize:number)
  {
    // get the maximum file size 
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find( p => p.Code=='MaxUploadMB1');
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = (fileSize/1000000);
    if (document_sizeMB <= maxAllowedSize)
    return 1;
    else return -1;
    //
  
    
  
  
  }
  validateData(documenttypeid:any) {
  
   
        
  
        if (this.dataCntrl.permit.id == null) {
            
            // this.dialogService.addDialog(AlertComponent, { title: 'Error', message: 'Unable to upload documents ' })
            this.toastr.error('Unable to upload documents! Please select permit type','Error')
  
            
        } else {
          
            this.postFile(documenttypeid)
        }
  
   
  }


  deleteDocument(item){
    let docs = JSON.parse(localStorage.getItem("uploads") || "[]");

    //console.log(item);
    this.isLoading = true;

    this.documentService.DeletePermitDoc(item.id).subscribe(data =>{
      //console.log(data);
      this.populateDocTypeList();
      this.documentService.getPermitById(this.dataCntrl.application.id).subscribe((x:any) => {
        for(var i = 0; i < x.length;i++){
          let firstNum =  x[i].document_link.indexOf('#')
          //console.log(x[i].document_link.substring(firstNum+1))
          x[i].shareId = x[i].document_link.substring(firstNum+1);
          //console.log(x[i].document_link.substring(0,firstNum))
          this.uploadedDocs.id = x[i].document_link.substring(firstNum+1);
          x[i].document_link = x[i].document_link.substring(0,firstNum);
          //console.log(x)
          this.uploadedDocs = x;
          //console.log(this.uploadedDocs)
          this.isLoading = false;

  
  
        }
        if (this.uploadedDocs.length > 0 )
       {
         this.removeUploadedDocTypes();
       }
       // this.populateDocTypeList();
        this.toastr.success('Document deleted successfully!')
  
      },error =>{
        if(error["_body"] !== undefined && error["_body"] !== null){
          this.uploadedDocs = [];

        }
        this.uploadedDocs = [];
        //console.log(error);
        
      })
      this.isLoading = false;

      

    })


  }
  deleteDoc(doc){
   
      this.showModal.showConfirm('Delete Document', 'Are you sure you want to delete?', `You're about to delete this document`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.deleteDocument(doc)
        } else {
          return;
        }
      });
    
  }
  cancelApplication(){
    if(this.dataCntrl.application.id==undefined && this.dataCntrl.application.id==null){
      this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);
    }else{
      this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.deleteApplication()
        } else {
          return;
        }
      });
    }
  }
  deleteApplication(){
    //console.log("delete application");

    this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x =>{
      //console.log(x);
    this.deleteApp(this.dataCntrl.application.id);

    this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);

    })
//this.dataCntrl.application.id
//this.dataCntrl.permit.id
  }
  deletePermit(id){
    this.permitService.deletePermit(id).subscribe(x =>{
      //console.log(x);
    })

  }
  deleteApp(id){
    this.applicationService.deleteApplication(id).subscribe(x =>{
      //console.log(x);
    })
  }
  onChange(event){
    //console.log(parseInt(event));
    this.getDocSaved(parseInt(event));
  }
  selectedDocType(event){
    //console.log(this.docTypeData)
  }
}
